/* src/app/ship/pickup-locations-dialog/pickup-locations-dialog.component.scss */
.dialog-header {
  z-index: 9;
}
.dialog-content {
  position: relative;
  height: 100%;
}
.dialog-content .content {
  max-height: 100%;
}
.dialog-content .dialog-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  border-top: solid thin rgba(0, 0, 0, 0.12);
  background-color: white;
  position: absolute;
  bottom: 0;
  z-index: 3;
}
.dialog-content .dialog-actions .mdc-button {
  width: 8rem;
}
.dialog-content .dialog-actions .access-point-code-offer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 0.25em;
  width: 100%;
  padding: 1rem;
  background-color: #F8FBFB;
}
.dialog-content .dialog-actions .access-point-code-offer .message-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  column-gap: 0.25em;
}
.dialog-content .dialog-actions .access-point-code-offer .message-wrapper img {
  filter: invert(0) sepia(0) saturate(1) hue-rotate(45deg);
}
.dialog-content .dialog-actions .access-point-code-offer .message-wrapper .message {
  font-size: 1.125em;
  font-weight: 600;
}
.dialog-content .dialog-actions .access-point-code-offer .access-point-code-option {
  font-size: 1em;
}
.dialog-content .dialog-actions .actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  justify-content: space-around;
  width: 100%;
  padding: 1rem;
}
:host(.pickup-locations-dialog) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
/*# sourceMappingURL=pickup-locations-dialog.component.css.map */
